module.exports = __webpack_public_path__ + "img/dislike.705533c9.svg";